import 'styles/global.scss';
import 'styles/figma-tokens.css';
import 'bootstrap';
import 'react-tooltip/dist/react-tooltip.css';

import { QueryClientProvider } from '@tanstack/react-query';

import { useState } from 'react';

import { CookieConsent } from 'components/CookieConsent/CookieConsent';
import { RybbitTracker } from 'components/RybbitTracker/RybbitTracker';
import { SitePreloader } from 'components/SitePreloader/SitePreloader';
import YandexMetrika from 'components/YandexMetrika/YandexMetrika';
import { NotificationsProvider } from 'notifications';

import { AppInternal } from './AppInternal';
import { queryClient } from './queryClient';
import { AuthContext, authContextDefaultValue } from './useAuth';

/** @deprecated import from 'app/queryClient' - re-export kept for gradual migration */
export { queryClient } from './queryClient';

/**
 * This is the root App element. Fill it only with root providers, for example Theme or QueryClient. To write the logic for processing the early rendering level (for example, redirect to the authorization page), use the AppInternal component.
 */
const App = () => {
  const [appReady, setAppReady] = useState(false);

  return (
    <NotificationsProvider>
      <QueryClientProvider client={queryClient}>
        <AuthContext value={authContextDefaultValue}>
          <SitePreloader appReady={appReady} />
          <AppInternal onReady={() => setAppReady(true)} />
          <YandexMetrika />
          <RybbitTracker />
          <CookieConsent />
        </AuthContext>
      </QueryClientProvider>
    </NotificationsProvider>
  );
};

export default App;
